<template>
  <el-dialog
    :visible="true"
    :fullscreen="true"
    :modal-append-to-body="true"
    :append-to-body="true"
    :close-on-click-modal="false"
    :before-close="handleClose"
    class="popupContainer"
    :title="showTypesModal?'选择需求类型':'请预留您的联系方式及需求信息'"
    :center="true"
  >
    <div
      v-if="!showTypesModal"
      class="introductionBox f-3 as-flex flex-vertical main-start cross-center"
    >
      <div
        class="indicator-sub-title as-flex main-center cross-center f-2 fc-gray-2"
      >众观智影为您提供精准的定制数据服务</div>
      <div class="indicator-content as-flex flex-vertical main-center cross-center">
        <div class="mobile-row as-flex main-start cross-center">
          <div class="mobile-title">联系方式</div>
          <div class="mobile-input">
            <input v-model="mobile" type="text" placeholder="请填写">
          </div>
        </div>
        <div class="mobile-row as-flex main-start cross-center">
          <div class="mobile-title">公司名称</div>
          <div class="mobile-input">
            <input v-model="company" type="text" placeholder="请填写">
          </div>
        </div>
        <div class="mobile-row as-flex main-start cross-center">
          <div class="mobile-title">影片名</div>
          <div class="mobile-input">
            <input v-model="movie" type="text" placeholder="请填写">
          </div>
        </div>
        <div class="mobile-row as-flex main-start cross-center">
          <div class="mobile-title">需求类型</div>
          <div class="types-input as-flex main-start cross-center" @click="showTypes">
            <div v-if="chosenTypes.length === 0" class="fc-gray-4 type-btn">请选择</div>
            <!-- <input
                v-if="chosenTypes.length === 0"
                @click.self.prevent="()=>{}"
                class="fc-gray-4 f-1"
                type="text"
                placeholder="请选择"
            >-->
            <div v-else class="types-container">{{chosenTypesText}}</div>
          </div>
        </div>
        <div class="requirementDetail-row as-flex main-center cross-center">
          <textarea v-model="questionDetail" class="requirementDetail" placeholder="您要解决的问题是?"></textarea>
        </div>
        <div class="error as-flex main-start cross-center f-1">{{error.msg}}</div>
        <!-- <div class="bottom-holder"></div> -->
      </div>
      <div class="confirm-btn as-flex main-center cross-center f-3" @click="confirm">提交</div>
      <!-- <span class="fc-gray-2 f-1 contact-us">
        <a class="fc-gray-2" :href="contact_num">联系我们</a>
      </span>-->
    </div>
    <div class="types-content" v-if="showTypesModal">
      <div class="indicator-content type-container as-flex flex-vertical main-start cross-start">
        <template v-for="(title,index) in Object.assign(typesMapping||{})">
          <div class="as-full-width" :key="'title_' + index">
            <div class="typeTitle f-4">{{title?title.name:'--'}}</div>
            <div
              :key="index"
              class="typeDetailContainer as-flex flex-vertical main-start cross-center"
            >
              <template v-for="item in title?title.data:[]">
                <div
                  @click="chooseType(item)"
                  :key="item.id"
                  :class="['type-box ','as-flex','flex-vertical' ,'main-center', 'cross-center',chosenTypes.find(ele => {return ele.id === item.id})?'is-selected':'']"
                >
                  <span>{{item.title}}</span>
                  <span class="f-1 fc-gray-2">{{item.desc}}</span>
                </div>
              </template>
            </div>
          </div>
        </template>
      </div>
      <div class="confirm-container as-flex main-center cross-center">
        <div class="confirm-btn as-flex main-center cross-center f-5" @click="confirmTypes">确定</div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { clone } from "lodash";
import feedbackApi from "../../api/feedbackApi.js";

export default {
  name: "requirement",
  props: {
    defaultConfig: {}
  },
  components: {},
  data() {
    return {
      feedbackApi: new feedbackApi(),
      mobile: undefined,
      contact: undefined,
      company: undefined,
      movie: undefined,
      questionDetail: undefined,
      error: {
        id: undefined,
        msg: ""
      },

      showTypesModal: false,
      chosenTypes: [],
      chosenTypesText: "",
      typesMapping: undefined
    };
  },
  computed: {
    formData: function() {
      return {
        mobile: this.mobile,
        company: this.company,
        movie: this.movie,
        questionDetail: this.questionDetail
      };
    }
  },
  methods: {
    getRealStringLength(string) {
      //中文占两var len = 0;
      let len = 0;
      for (let i = 0; i < string.length; i++) {
        if (string.charCodeAt(i) > 127 || string.charCodeAt(i) == 94) {
          len += 2;
        } else {
          len++;
        }
      }
      return len;
    },
    getMaxLengthString(string, maxLength) {
      let curLen = 0;
      let curStr = "";
      for (let i = 0; i < string.length; i++) {
        if (string.charCodeAt(i) > 127 || string.charCodeAt(i) == 94) {
          if (curLen + 2 > maxLength) {
            return curStr;
          }
          curLen += 2;
          curStr += string[i];
        } else {
          if (curLen + 1 > maxLength) {
            return curStr;
          }
          curLen++;
          curStr += string[i];
        }
      }
      return curStr;
    },
    showTypes(e) {
      e.stopImmediatePropagation();
      this.showTypesModal = true;
    },
    confirmTypes() {
      this.showTypesModal = false;
    },
    chooseType(data) {
      let ischosen = this.chosenTypes.find(ele => {
        return ele.id === data.id;
      });
      if (ischosen) {
        this.chosenTypes = this.chosenTypes.filter(item => {
          return item.id !== data.id;
        });
      } else {
        this.chosenTypes.push(data);
      }
    },
    handleClose() {
      this.closePopup();
    },
    closePopup() {
      this.$emit("closeModal");
    },
    validate() {
      if (!this.mobile || this.mobile.length !== 11) {
        //手机号码必填
        this.error.id = 1;
        this.error.msg = "请填写11位手机号码";
        return false;
      } else if (!this.questionDetail) {
        //需求说明必填
        this.error.id = 2;
        this.error.msg = "请填写需求说明";
        return false;
      }
      this.error = { id: undefined, msg: "" };
      return true;
    },
    fixValidate() {
      if (this.mobile && this.mobile.length === 11 && this.error.id === 1) {
        //手机号码必填
        this.error = { id: undefined, msg: "" };
      } else if (this.questionDetail && this.error.id === 2) {
        //需求说明必填
        this.error = { id: undefined, msg: "" };
      }
    },
    async confirm() {
      let validation = this.validate();
      if (!validation) {
        return;
      }
      let res = await this.feedbackApi.commitRequirement({
        contact: this.mobile,
        movie_name: this.movie,
        company: this.company,
        category: this.chosenTypes.map(item => {
          return item.id;
        }),
        description: this.questionDetail
      });
      if (res.code === 200) {
        this.$message.success({
          message: "需求提交成功，工作人员将尽快与您联系",
          duration: 3000
        });
        this.closePopup();
      } else {
        this.$message.error({
          message: res.msg
        });
      }
    }
  },
  async created() {
    let res = await this.feedbackApi.getRequirementTypes();
    if (res.code !== 200) {
      this.$message.error({
        message: res.msg
      });
    }
    this.typesMapping = clone(res.data);
  },
  mounted() {},
  watch: {
    company: function(to, from) {
      if (this.getRealStringLength(to) > 40) {
        //toast提示
        this.$message.error({
          message: "公司名限制40个字符/20个汉字",
          duration: 3000
        });
        this.company = this.getMaxLengthString(to, 40);
      }
    },
    movie: function(to, from) {
      if (this.getRealStringLength(to) > 40) {
        //toast提示
        this.$message.error({
          message: "影片名限制40个字符/20个汉字",
          duration: 3000
        });
        this.movie = this.getMaxLengthString(to, 40);
      }
    },
    questionDetail: function(to, from) {
      if (this.getRealStringLength(to) > 600) {
        //toast提示
        this.$message.error({
          message: "需求说明限制600字符/300汉字",
          duration: 3000
        });
        this.questionDetail = this.getMaxLengthString(to, 600);
      }
    },
    formData: {
      handler: function(to, from) {
        if (from.mobile === undefined) {
          return;
        }
        this.fixValidate();
      },
      deep: true
    },
    chosenTypes: {
      handler: function(to, from) {
        let text = to
          .map(item => {
            return item.title;
          })
          .join("、");
        this.chosenTypesText = text;
      },
      deep: true
    }
  },
  created() {
    this.mobile = this.$store.getters["user/getUserInfo"].mobile;
    this.company = this.$store.getters["user/getUserInfo"].company;
  }
};
</script>

<style lang="scss" scoped>
.popupContainer {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 500px;
  height: 720px;
  border-radius: 20px;
  padding: 20px;
  .indicator-content {
    margin: 30px 10px 10px 10px;
    width: 100%;
    overflow-y: scroll;
  }
  .types-content {
    width: 100%;
    overflow-y: scroll;
  }
  .type-container {
    margin: 0;
    width: 100%;
    flex-wrap: nowrap;
  }
  .types-input {
    width: calc(100% - 100px);
    text-overflow: ellipsis;
    overflow: hidden;
    // white-space: nowrap;
  }
  .typeDetailContainer {
    flex-shrink: 0;
    flex-grow: 0;
    width: 100%;
  }
}
.confirm-container {
}
.typeTitle {
  margin: 20px 0 20px 0;
}
.confirm-btn {
  cursor: pointer;
  margin: 10px;
  width: 250px;
  height: 40px;
  background-color: #008cd6;
  border-radius: 20px;
  color: #fff;
}
.introductionBox {
  .indicator-sub-title {
  }
}
.mobile-row {
  height: 50px;
  width: 100%;
  border-bottom: 1px solid #eee;
  margin: 8px 0;
  .mobile-title {
    width: 100px;
    font-size: 15px;
  }
  .mobile-input {
    width: calc(100% - 100px);
  }
}
.requirementDetail-row {
  width: 100%;
  margin: 15px 0;
}
.requirementDetail {
  width: 100%;
}
.error {
  width: 100%;
  height: 40px;
  color: red;
}
.bottom-holder {
  visibility: hidden;
  height: 1.4rem;
  width: 100%;
}

.contact-us {
}

.type-box {
  height: 60px;
  padding: 20px 10px;
  min-width: 60%;
  margin: 20px;
  border: 1px solid #eeeeee;
  white-space: nowrap;
  &.is-selected {
    border: 1px solid #008cd6;
  }
}
.types-container {
  width: 100%;
  height: 50px;
  padding: 5px;
  font-size: 10px;
  line-height: 25px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  // text-overflow: ellipsis;
  // overflow: hidden;
  // white-space: nowrap;
  // flex-wrap: wrap;
  .type-show {
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
.input-holder {
}
.type-btn {
  font-size: 12px !important;
}

/deep/ .el-dialog {
  border-radius: 20px;
}

input {
  font-size: 12px;
  outline: none;
  height: 49px;
  width: 100%;
  color: #999999;
  border: none;
}
input::hover {
  outline: none;
}
input::-webkit-input-placeholder {
  font-size: 12px !important;
  color: #b7b7b7;
}

input:-moz-placeholder {
  font-size: 12px !important;
  color: #b7b7b7;
}

input:-ms-input-placeholder {
  font-size: 12px !important;
  /* IE10+ */
  color: #b7b7b7;
}

textarea {
  min-height: 100px;
  resize: none;
  outline: none;
  color: #666666;
  border: 1px solid #eee;
  border-radius: 0;
  padding: 4px;
  -webkit-appearance: none;
}
textarea::hover {
  outline: none;
}

/deep/ .el-dialog__body {
  padding: 10px 25px 30px !important;
}
</style>
